import * as React from "react"
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg"


export default function CategoryEndGrad(props: any) {
    return (
      <Svg
        width={44}
        height={44}
        viewBox="0 0 44 44"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <Path fill="url(#paint0_linear_2697_856)" d="M0 0H44V44H0z" />
        <Defs>
          <LinearGradient
            id="paint0_linear_2697_856"
            x1={-3.69481e-7}
            y1={20.5}
            x2={44}
            y2={20.5}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#E7E6E1" />
            <Stop offset={.4} stopColor="#E6E7E1" stopOpacity={0.969} />
            <Stop offset={1} stopColor="#E6E7E1" stopOpacity={0} />
          </LinearGradient>
        </Defs>
      </Svg>
    )
  }
  